// import img
import img1 from '../../assets/img/common/1.jpg'

export const  TableData = [
{
    order_id:"#21515",
    img:img1,
    product_Name:"Neck Velvet Dress",
    price:"$145",
    sales:"200",
    category:"Women Clothes",
    stock:"100",
    status:"Confrimed"
},
{
    order_id:"#78153",
    img:img1,
    product_Name:"Belted Trench Coat",
    price:"$145",
    sales:"200",
    category:"Women Clothes",
    stock:"100",
    status:"Shipped"
},
{
    order_id:"#51512",
    img:img1,
    product_Name:"Man Print Tee",
    price:"$145",
    sales:"200",
    category:"Women Clothes",
    stock:"100",
    status:"Pending"
},
{
    order_id:"#21515",
    img:img1,
    product_Name:"Neck Velvet Dress",
    price:"$145",
    sales:"200",
    category:"Women Clothes",
    stock:"100",
    status:"Confrimed"
},
{
    order_id:"#21515",
    img:img1,
    product_Name:"Neck Velvet Dress",
    price:"$145",
    sales:"200",
    category:"Women Clothes",
    stock:"100",
    status:"Confrimed"
},
{
    order_id:"#21515",
    img:img1,
    product_Name:"Neck Velvet Dress",
    price:"$145",
    sales:"200",
    category:"Women Clothes",
    stock:"100",
    status:"Confrimed"
},
{
    order_id:"#21515",
    img:img1,
    product_Name:"Neck Velvet Dress",
    price:"$145",
    sales:"200",
    category:"Women Clothes",
    stock:"100",
    status:"Confrimed"
}
]